// Vendors
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Redirect } from 'react-router-dom';

//Requests
import { getLookUpDataAndRenewDMVRegistration } from '../../../reducers/agency/dmv/dmvActions';

// Types
import { AppParamsPropTypes } from '../../../components/common/Forms/LinkServiceLookupForm/LinkServiceLookupForm';

// PRJ1417943 - Integration Accelerator - Dynamically load all agency LinkServiceSuccess components
const successContext = require.context(
  '../../../agencies',
  true,
  /link-service\/LinkServiceSuccess\.js$/
);
const agencySuccessComponents = {};
successContext.keys().forEach(key => {
  // Extract agency slug from path, e.g. './DPS/link-service/LinkServiceSuccess.js' => 'dps'
  const match = key.match(/\.\/(.*?)\/link-service\/LinkServiceSuccess\.js$/);
  if (match) {
    const slug = match[1].toLowerCase();
    agencySuccessComponents[slug] = successContext(key).default;
  }
});

const LinkServiceSuccess = ({ link }) => {
  if (!link || !link.agency || !link.app || !link.success)
    return <Redirect to="/link" />;

  const { agency } = link;
  const AgencyLinkServiceSuccess = agencySuccessComponents[agency.agencySlug];
  
  if (AgencyLinkServiceSuccess) {
    return <AgencyLinkServiceSuccess link={link} />;
  }
  
  return <></>;
};

const mapStateToProps = ({ agency: { link } }) => ({ link });
const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getLookUpDataAndRenewDMVRegistration,
    },
    dispatch
  );

LinkServiceSuccess.propTypes = {
  link: PropTypes.shape({
    params: PropTypes.arrayOf(AppParamsPropTypes),
    agency: PropTypes.object,
    app: PropTypes.object,
    linkData: PropTypes.object,
    success: PropTypes.object,
    relinkData: PropTypes.string,
  }).isRequired,
  getLookUpDataAndRenewDMVRegistration: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(LinkServiceSuccess);
